import dayjs from 'dayjs';
import { DateValue } from './date-value';

export const dateParse = (date: DateValue, format: string): Date => {
  return dayjs(date, format).toDate();
};
